import SubscriptionForm from './subscription-form';

const subscriptionFormConfig = {
  name: 'subscriptionForm',
  class: SubscriptionForm,
  querySelector: {},
  querySelectorAll: {},
  options: {},
};

export default subscriptionFormConfig;
